export default {"src":"/_next/static/media/yahoo_finance.6fd8cd46.svg","height":20,"width":142,"blurWidth":0,"blurHeight":0};